export const TEST_REASON = {
  COMPLETE: 'complete',
  EXIT: 'exit',
  TIMEOUT: 'timeout',
} as const;

export type TestReason = (typeof TEST_REASON)[keyof typeof TEST_REASON];
